/* Arachne cart guard: a designed item has exactly one layout, so its quantity stays at 1 until a second layout is made. */
(function(){
if(window.__arachneGuard)return;window.__arachneGuard=1;
var of=window.fetch.bind(window);
function modal(item,mode,quilt){
  var d=document.createElement('div');
  d.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:grid;place-items:center;padding:20px';
  var what=mode==='jacket'?'jacket':'hoodie';
  var href=quilt?'/pages/design#quilt:'+encodeURIComponent(quilt)+':'+(mode==='jacket'?'jacket':'hoodie'):'/pages/design';
  d.innerHTML='<div role="dialog" aria-modal="true" style="background:#fff;color:#111;border-radius:12px;max-width:440px;width:100%;padding:22px;font:15px/1.45 system-ui,sans-serif"><h3 style="margin:0 0 8px;font-size:19px">Only one layout so far</h3><p style="margin:0 0 16px">You laid out a pattern for one '+what+' on this quilt, so we can only make one. To buy two, lay out a second pattern first so we know exactly how you want each one made.</p><div style="display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap"><button id="ag-ok" style="padding:10px 14px;border:1px solid #111;border-radius:6px;background:#fff;cursor:pointer">Keep one</button><a id="ag-go" href="'+href+'" style="padding:10px 14px;border-radius:6px;background:#111;color:#fff;text-decoration:none">Lay out the second one</a></div></div>';
  document.body.appendChild(d);
  d.querySelector('#ag-ok').onclick=function(){d.remove();location.reload()};
}
function parseBody(b){
  if(!b)return null;
  if(typeof b==='string'){try{return JSON.parse(b)}catch(e){var p=new URLSearchParams(b);var o={};p.forEach(function(v,k){o[k]=v});return o}}
  if(typeof FormData!=='undefined'&&b instanceof FormData){var o2={};b.forEach(function(v,k){o2[k]=v});return o2}
  if(typeof URLSearchParams!=='undefined'&&b instanceof URLSearchParams){var o3={};b.forEach(function(v,k){o3[k]=v});return o3}
  return null;
}
function blocked(data){
  return of('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
    var items=cart.items||[],hit=null;
    function consider(item,qty){if(item&&item.properties&&item.properties._design&&+qty>1)hit=item}
    if(data.line)consider(items[+data.line-1],data.quantity);
    else if(data.id&&data.quantity!=null){items.forEach(function(it){if(String(it.key)===String(data.id)||String(it.id)===String(data.id))consider(it,data.quantity)})}
    if(data.updates){var u=data.updates;if(Array.isArray(u))u.forEach(function(q,i){consider(items[i],q)});else Object.keys(u).forEach(function(k){items.forEach(function(it){if(String(it.key)===k||String(it.id)===k)consider(it,u[k])})})}
    return hit;
  }).catch(function(){return null});
}
window.fetch=function(input,init){
  try{
    var url=typeof input==='string'?input:(input&&input.url)||'';
    if(/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)&&init&&init.body){
      var data=parseBody(init.body);
      if(data)return blocked(data).then(function(hit){
        if(!hit)return of(input,init);
        var mode='hoodie',quilt='';try{var dj=JSON.parse(hit.properties._design);mode=dj.mode||'hoodie';quilt=dj.quilt||''}catch(e){}
        modal(hit,mode,quilt);
        return new Response(JSON.stringify({status:422,message:'Only one layout',description:'Lay out a second pattern before buying two.'}),{status:422,headers:{'Content-Type':'application/json'}});
      });
    }
  }catch(e){}
  return of(input,init);
};
})();
